/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Group_LevelupsInputs */



/**
* | output |
* | --- |
* | "Level-ups and cards" |
*
* @param {Pricing_Compare_Group_LevelupsInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_group_levelups = /** @type {((inputs?: Pricing_Compare_Group_LevelupsInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Group_LevelupsInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Повышения уровня и карточки")
	return /** @type {LocalizedString} */ ("Level-ups and cards")
});